"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getString = void 0;
const character_1 = require("./character");
const skip_1 = require("./skip");
const Error_1 = require("./Error");
const getString = (input, start) => {
    const quote = input.codePointAt(start);
    if (quote !== character_1.DoubleQuote && quote !== character_1.SingleQuote) {
        throw new Error_1.$Error('InvalidQuote', input[start]);
    }
    const isNotQuoteOrBackslash = (0, character_1.isNot)(quote, character_1.Backslash);
    const fragments = [];
    let end = start + 1;
    while (1) {
        const fragmentStart = end;
        end = (0, skip_1.skip)(input, end, isNotQuoteOrBackslash);
        fragments.push(input.slice(fragmentStart, end));
        const charCode = input.codePointAt(end);
        if (charCode === character_1.Backslash) {
            fragments.push(input.charAt(end + 1));
            end += 2;
        }
        else if (charCode === quote) {
            return {
                start,
                end: end + 1,
                value: fragments.join(''),
            };
        }
        else {
            break;
        }
    }
    throw new Error_1.$Error('UnterminatedString');
};
exports.getString = getString;
